module.exports = "<div class=\"row center-xs\">\n  <div class=\"main-container col-xs-12\">\n    <div class=\"main-container-body row\">\n      <div class=\"col-xs-12\">\n        <div class=\"terms-container row center-xs\">\n          <div class=\"text col-xs-12 col-sm-10 text-left\" [innerHTML]=\"merchant_terms\"[style.color]=\"text_color\"></div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/referral-magic/merchant-terms/merchant-terms.component.html
// module id = ../../../../../../../../src/app/referral-magic/merchant-terms/merchant-terms.component.html
// module chunks = 1